import { render, staticRenderFns } from "./PickupDelivery.vue?vue&type=template&id=06b33fd2&scoped=true"
import script from "./PickupDelivery.vue?vue&type=script&lang=js"
export * from "./PickupDelivery.vue?vue&type=script&lang=js"
import style0 from "./PickupDelivery.vue?vue&type=style&index=0&id=06b33fd2&prod&lang=scss"
import style1 from "./PickupDelivery.vue?vue&type=style&index=1&id=06b33fd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b33fd2",
  null
  
)

export default component.exports